import { api } from './api';
// import mockService from './mocks';

const changeSubdomain = async (payload, isMocking) => {
	//   console.log('TCL: fetchSettings -> payload, isMocking', payload, isMocking);
	let data;
	if (isMocking) {
		// data = await mockService.fetchSettings();
	} else {
		const response = await api.post(
			'/private/rest/accounts/adviser_agent/save_sitesettings_subdomain/',
			payload,
			{
				withCredentials: true
			}
		);
		console.log('TCL: changeSubdomain -> response', response);
		data = response.data;
	}

	// console.log('TCL: fetchSettings -> data', data);
	return data;
};

const saveOtherSettings = async (payload, isMocking) => {
	//   console.log('TCL: fetchSettings -> payload, isMocking', payload, isMocking);
	let data;
	if (isMocking) {
		// data = await mockService.fetchSettings();
	} else {
		const response = await api.post(
			'/private/rest/accounts/adviser_agent/save_advisorpreference_othersettings/',
			payload,
			{
				withCredentials: true
			}
		);
		// console.log('TCL: saveOtherSettings -> response', response);
		data = response.data;
	}

	// console.log('TCL: fetchSettings -> data', data);
	return data;
};

const saveAllSettings = payload => {
	return api.post(
		`${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/save_sitesettings_details/`,
		payload,
		{
			withCredentials: true
		}
	);
};

export { changeSubdomain, saveAllSettings, saveOtherSettings };
